import React, { useCallback, useEffect, useState } from "react";
import DefaultImage from "../../../img/app/default-Image.webp";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { toScreen } from "../../../js/modules/Routing";
import { defaultAvatarImage, imageFormat, jobImagesFolder, serverUrl, thumbSuffix, userImagesFolder } from "../../../config/env";
import { defaultMessagesFilter } from "../../../config/constants";

import {
  AdminIcon,
  CalenderIcon,
  CloseIcon,
  CopyIcon,
  CopySuccessIcon,
  MessageIcon,
  StarEmptyIcon,
  StarIcon,
} from "../../commonUI/Icons/SvgIcon";
import { toast } from "react-toastify";
import { closeSpinner, showSpinner } from "../../../js/modules/Dialogs";
import { markTransfer } from "../../../services/transferService";

const TransfersDetails = ({
  onClose,
  selectedTransfer,
  theCallBackFunc,
  userDetails,
}) => {
  const [activeTab, setActiveTab] = useState("driverdetails");
  const [copiedJobId, setCopiedJobId] = useState(false);
  const [driverId, setDriverId] = useState("");
  const [clientId, setClientId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleJobIdCopy = () => {
    const shortId = selectedTransfer?.jobDetails?.shortId || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setCopiedJobId(true);
      setTimeout(() => setCopiedJobId(false), 1500);
    }
    toast.success("ID copied to clipboard");
  };

  const handleClientIdCopy = () => {
    const shortId = selectedTransfer?.userDetails?.shortId || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setClientId(true);
      setTimeout(() => setClientId(false), 1500);
    }
    toast.success("ID copied to clipboard");
  };

  const handleDriverIdCopy = () => {
    const shortId = selectedTransfer?.driverDetails?.shortId || "";
    if (shortId) {
      navigator.clipboard.writeText(shortId);
      setDriverId(true);
      setTimeout(() => setDriverId(false), 1500);
    }
    toast.success("ID copied to clipboard");
  };

  const handleMarkTransfer = useCallback(
    async ({ jobId, paymentTransfer }) => {
      showSpinner();

      const markTransfer_done = (resStatus, responseString, resJson) => {
        closeSpinner();

        if (resStatus === 200) {
          toast.success("Transfer marked successfully");
          theCallBackFunc?.();
          onClose?.();
        } else if (resStatus === 400) {
          toast.error(resJson?.message || responseString || "Bad Request");
        } else {
          toast.error(
            resJson?.message || responseString || "Something went wrong!"
          );
        }
      };

      const payload = {
        jobId,
        paymentTransfer,
      };

      try {
        markTransfer(payload, markTransfer_done, userDetails?.jwttoken);
      } catch (error) {
        closeSpinner();
        toast.error("Failed to process refund decision");
      }
    },
    [theCallBackFunc, onClose, userDetails?.jwttoken]
  );

  const getDriverAvatarSrc = useCallback((selectedTransfer) => {
    if (
      selectedTransfer?.driverDetails?.avatar &&
      selectedTransfer?.driverDetails?.avatar !== ""
    ) {
      return `${serverUrl}${userImagesFolder}/${selectedTransfer?.driverDetails?.shortId}/${selectedTransfer?.driverDetails?.avatar}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${defaultAvatarImage}${imageFormat}`;
  }, []);

  const getClientAvatarSrc = useCallback((selectedTransfer) => {
    if (
      selectedTransfer?.driverDetails?.avatar &&
      selectedTransfer?.driverDetails?.avatar !== ""
    ) {
      return `${serverUrl}${userImagesFolder}/${selectedTransfer?.driverDetails?.shortId}/${selectedTransfer?.driverDetails?.avatar}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${defaultAvatarImage}${imageFormat}`;
  }, []);

  const getJobDetailsSrc = useCallback((selectedTransfer, image) => {
    const shortId = selectedTransfer?.jobDetails?.shortId;
    if (image && shortId) {
      return `${serverUrl}${jobImagesFolder}/${shortId}/${image}${thumbSuffix}${imageFormat}`;
    }
    return `../img/${DefaultImage}${imageFormat}`;
  }, []);


  const calculateCommission = useCallback((selectedTransfer) => {
    const commission = (selectedTransfer?.jobDetails?.bookedFor * selectedTransfer?.jobDetails?.commission) / 100 || 0;
    return commission.toFixed(2);
  }, []);

    const calculateDriverPay = useCallback((selectedTransfer) => {
      const clientPaid = selectedTransfer?.jobDetails?.bookedFor / 100 || 0;
      const commission = (selectedTransfer?.jobDetails?.bookedFor * selectedTransfer?.jobDetails?.commission) / 100 || 0;
      const driverPay = clientPaid - commission;
      return driverPay.toFixed(2);
    }, []);

  const calculateClientPaid = useCallback((selectedTransfer) => { 
    const clientPaid = selectedTransfer?.jobDetails?.bookedFor / 100 || 0;
    return clientPaid.toFixed(2);
  }, []);


  return (
    <div className="right-modal reviewTransfer-modal">
      {/* Modal Header */}
      <div className="modal-header">
        <div className="modal-title">
          <h2>Review Transfer Details</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        <div className="modal-card mb-24">
          <div className="p-24">
            <div className="quote-profile p-0 bg-transparent">
              <div className="d-flex align-items-center g-12">
                <div>
                  <div className="d-flex align-items-center g-8">
                    <div>
                      <h4 className="mb-0 text-lg text-capitalize g-8">
                        <span>
                          {selectedTransfer?.driverDetails?.firstname ||
                            "Michael Johnson"}
                        </span>

                        <span
                          className={`text-capitalize badge ms-8 ${
                            selectedTransfer?.jobDetails?.status === "open"
                              ? "badge-info"
                              : selectedTransfer?.jobDetails?.status ===
                                "closed"
                              ? "badge-danger"
                              : selectedTransfer?.jobDetails?.status === "paid"
                              ? "badge-warning"
                              : selectedTransfer?.jobDetails?.status ===
                                "complete"
                              ? "badge-success"
                              : ""
                          }`}
                        >
                          {selectedTransfer?.jobDetails?.status}
                        </span>
                      </h4>

                      <button
                        onClick={handleDriverIdCopy}
                        className="badge copyCode-btn"
                      >
                        {selectedTransfer?.jobDetails?.shortId?.toUpperCase()}

                        {copiedJobId ? <CopySuccessIcon /> : <CopyIcon />}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center g-12 ms-auto">
                <button
                  className="btn-outline-light icon-with-btn"
                  onClick={(e) =>
                    toScreen(
                      e,
                      navigate,
                      `/mav/${selectedTransfer?.driverDetails?.shortId}`
                    )
                  }
                >
                  Details
                </button>
              </div>
            </div>
            {/* Refund Info */}
            <div className="refund-info">
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Driver pay</span>
                <span className="fw-bold">
                  £
                  {calculateDriverPay(selectedTransfer) || "0"}
                </span>

              </div>
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Commission({selectedTransfer?.jobDetails?.commission *100}%)</span>
                <span className="fw-bold">
                  £{calculateCommission(selectedTransfer) || "0"}
                </span>
              </div>
              <div className="refund-info-item">
                <span className="text-sm text-gray-500">Client paid</span>
                <span className="fw-bold">
                  £{calculateClientPaid(selectedTransfer) || "0"}
                </span>
              </div>
            </div>

            <div className="client-review border-top-0 pt-0">
              <h3 className="text-sm mb-8">Client Review</h3>

              <div className="client-review-item border-gray">
                {[...Array(selectedTransfer?.ratings?.stars || 0)].map(
                  (_, index) => (
                    <StarIcon key={index} />
                  )
                )}
                <p className="text-sm review-content">
                  {selectedTransfer?.ratings?.comment || "No Review Found"}
                </p>
                <p className="review-name">
                  — {selectedTransfer?.userDetails?._creator}
                </p>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-card mb-24">
          <div className="custom-tabs m-0">
            <div
              className={`tab-item ${
                activeTab === "driverdetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("driverdetails")}
            >
              Driver details
            </div>
            <div
              className={`tab-item ${
                activeTab === "jobdetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("jobdetails")}
            >
              Job details
            </div>

            <div
              className={`tab-item ${
                activeTab === "clientdetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("clientdetails")}
            >
              Client details
            </div>
          </div>
          {/* Profile Info */}
          {activeTab === "driverdetails" && (
            <>
              <div className="quote-profile">
                <div className="d-flex align-items-center g-12">
                  <div className="d-flex align-items-center g-12">
                    <img
                      src={getDriverAvatarSrc(selectedTransfer)}
                      alt="avatar"
                      className="avatar-pic"
                      onError={(e) => {
                        e.target.src = defaultAvatarImage;
                      }}
                    />
                    <div className="text-capitalize">
                      {selectedTransfer?.driverDetails?.firstname || "-"}
                      <br />
                      <span className="text-sm text-gray-600 ">
                        <button
                          onClick={handleDriverIdCopy}
                          className="badge copyCode-btn"
                        >
                          {selectedTransfer?.driverDetails?.shortId?.toUpperCase()}

                          {driverId ? <CopySuccessIcon /> : <CopyIcon />}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        "/message/" + selectedTransfer?.driverDetails?.shortId,
                        false,
                        {
                          receiverId: selectedTransfer?.driverDetails?._id,
                          receiverShortId:
                            selectedTransfer?.driverDetails?.shortId,
                          receiverType: "user",
                          userShortId1: "admin",
                          userShortId2:
                            selectedTransfer?.driverDetails?.shortId,
                          username2:
                            selectedTransfer?.driverDetails?.accountInfo
                              ?.username,
                          selectedPage:
                            window.history.state?.usr?.selectedPage ?? 1,
                          selectedFilter:
                            window.history.state?.usr?.selectedFilter ??
                            defaultMessagesFilter,
                          previousPath:
                            window.history.state?.usr?.previousPath ??
                            window.location.pathname,
                        }
                      )
                    }
                  >
                    <MessageIcon />
                  </button>
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        `/mav/${selectedTransfer?.driverDetails?.shortId}`
                      )
                    }
                  >
                    Details
                  </button>
                </div>
              </div>
              <div className="p-24">
                <ul className="profile-info">
                  <li className="profile-info-item">
                    <span className="profile-info-title">Rating</span>
                    <p className="text-capitalize">
                      {selectedTransfer?.driverDetails?.ratings || "0"}
                    </p>
                  </li>
                  {/* <li className="profile-info-item">
                    <span className="profile-info-title">Joined on</span>
                    <p className="text-capitalize">
                      {selectedTransfer?.accountInfo?.surname}
                    </p>
                  </li> */}
                  <li className="profile-info-item ">
                    <span className="profile-info-title">Jobs</span>
                    <p className="text-capitalize">
                      {`${
                        (selectedTransfer?.driverDetails?.completedQuotes ||
                          0) +
                        (selectedTransfer?.driverDetails?.refundedQuotes || 0)
                      } booked / ${
                        selectedTransfer?.driverDetails?.cancellationRate || 0
                      } cancelled`}
                    </p>
                  </li>
                  <li className="profile-info-item">
                    <span className="profile-info-title">Quotes</span>
                    <p>{selectedTransfer?.driverDetails?.quoteCount}</p>
                  </li>
                </ul>
              </div>
            </>
          )}
          {/* Notification List */}
          {activeTab === "jobdetails" && (
            <>
              <div className="quote-profile">
                <div className="d-flex align-items-center g-12">
                  <div>
                    <h4 className="mb-0 text-lg text-capitalize">
                      {selectedTransfer?.jobDetails?.jobType || "-"}
                      <span
                        className={`text-capitalize badge ms-8 ${
                          selectedTransfer?.jobDetails?.status === "open"
                            ? "badge-info"
                            : selectedTransfer?.jobDetails?.status === "closed"
                            ? "badge-danger"
                            : selectedTransfer?.jobDetails?.status === "paid"
                            ? "badge-warning"
                            : selectedTransfer?.jobDetails?.status ===
                              "complete"
                            ? "badge-success"
                            : ""
                        }`}
                      >
                        {selectedTransfer?.jobDetails?.status}
                      </span>{" "}
                    </h4>

                    <p className="text-sm text-gray-600">
                      <button
                        onClick={handleJobIdCopy}
                        className="badge copyCode-btn"
                      >
                        {selectedTransfer?.jobDetails?.shortId?.toUpperCase()}

                        {copiedJobId ? <CopySuccessIcon /> : <CopyIcon />}
                      </button>
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(e, navigate, `/client/${transfer?.short_id}`)
                    }
                  >
                    Details
                  </button>
                </div>
              </div>
              <div className="job-images p-24 mb-0 pb-0">
                {selectedTransfer?.jobDetails?.images?.length > 0 &&
                  selectedTransfer?.jobDetails?.images.map((image, index) => (
                    <div className="job-image" key={index}>
                      <a
                        href={getJobDetailsSrc(selectedTransfer, image)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={getJobDetailsSrc(selectedTransfer, image)}
                          alt={`Job image ${index + 1}`}
                          className="c-avatar__pic"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `../img/${DefaultImage}${imageFormat}`;
                          }}
                        />
                      </a>
                    </div>
                  ))}
              </div>

              <ul className="profile-info p-24">
                <li className="profile-info-item">
                  <span className="profile-info-title">Posted on</span>
                  <p>
                    {" "}
                    {moment(selectedTransfer?.jobDetails?.creationDate).format(
                      "DD MMM , YYYY hh:mm A"
                    ) || "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Quotes received</span>
                  <p>{selectedTransfer?.jobDetails?.quoteCount || "-"}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">From</span>
                  <p>{selectedTransfer?.jobDetails?.from || "-"}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">To</span>
                  <p>{selectedTransfer?.jobDetails?.to || "-"}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Booked on</span>
                  <p>
                    {" "}
                    {moment(selectedTransfer?.jobDetails?.bookedOn).format(
                      "DD MMM , YYYY hh:mm A"
                    ) || "-"}
                  </p>
                </li>{" "}
                <li className="profile-info-item">
                  <span className="profile-info-title">Completed on</span>
                  <p>
                    {moment(selectedTransfer?.jobDetails?.completedOn).format(
                      "DD MMM , YYYY hh:mm A"
                    ) || "-"}
                  </p>
                </li>
              </ul>
            </>
          )}

          {/* {Client list} */}
          {activeTab === "clientdetails" && (
            <>
              <div className="quote-profile">
                <div className="d-flex align-items-center g-12">
                  <div className="d-flex align-items-center g-12">
                    <img
                      src={getClientAvatarSrc(selectedTransfer)}
                      alt="Client Avatar"
                      className="avatar-pic"
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = `../img/${defaultAvatarImage}${imageFormat}`;
                      }}
                    />

                    <div className="text-capitalize">
                      {selectedTransfer?.userDetails?.firstname || "-"}
                      <br />
                      <span className="text-sm text-gray-600 ">
                        <button
                          onClick={handleClientIdCopy}
                          className="badge copyCode-btn"
                        >
                          {selectedTransfer?.userDetails?.shortId?.toUpperCase()}

                          {clientId ? <CopySuccessIcon /> : <CopyIcon />}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center g-12 ms-auto">
                  <button
                    className="btn-outline-light icon-with-btn"
                    onClick={(e) =>
                      toScreen(
                        e,
                        navigate,
                        "/message/" + selectedTransfer?.userDetails?.shortId,
                        false,
                        {
                          receiverId: selectedTransfer?.userDetails?._id,
                          receiverShortId:
                            selectedTransfer?.userDetails?.shortId,
                          receiverType: "user",
                          userShortId1: "admin",
                          userShortId2: selectedTransfer?.userDetails?.shortId,
                          username2:
                            selectedTransfer?.userDetails?.accountInfo
                              ?.username,
                          selectedPage:
                            window.history.state?.usr?.selectedPage ?? 1,
                          selectedFilter:
                            window.history.state?.usr?.selectedFilter ??
                            defaultMessagesFilter,
                          previousPath:
                            window.history.state?.usr?.previousPath ??
                            window.location.pathname,
                        }
                      )
                    }
                  >
                    <MessageIcon />
                  </button>
                </div>
              </div>
              <ul className="profile-info p-24">
                <li className="profile-info-item">
                  <span className="profile-info-title">Phone</span>
                  <p>{selectedTransfer?.userDetails?.telephone || "-"}</p>
                  <div className="client-rating-info"></div>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Email</span>
                  <p className="word-wrap">
                    {selectedTransfer?.userDetails?.email || "-"}
                  </p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Jobs</span>
                  <p>{`${
                    selectedTransfer?.userDetails?.jobCount || "0"
                  } posted, ${
                    selectedTransfer?.userDetails?.completedJobs || "0"
                  } booked`}</p>
                </li>
                <li className="profile-info-item">
                  <span className="profile-info-title">Registered</span>
                  <p>
                    {selectedTransfer?.userDetails?.registeredOn
                      ? moment(
                          selectedTransfer?.userDetails?.registeredOn
                        ).format("DD MMM,YYYY")
                      : "-"}
                  </p>
                </li>
              </ul>
            </>
          )}
        </div>
        <div className="modal-card mb-0">
          <div className="px-24 py-20">
            <h3 className="fw-semibold mb-0">Driver profile notes</h3>
          </div>
          <div className="p-24 pt-0">
            {selectedTransfer?.jobDetails?.notes?.map((note, index) => {
              // Strip <p> tags if they exist
              const strippedContent = note?.content
                ?.replace(/^<p>/i, "")
                ?.replace(/<\/p>$/i, "");

              return (
                <div className="driver-profile-notes mb-24" key={index}>
                  <div className="d-flex align-items-center g-12">
                    <div className="d-flex align-items-center g-4">
                      {note?.createdAt && (
                        <span className="text-xs text-gray-600 d-flex align-items-center gap-1">
                          <CalenderIcon />
                          {moment(note?.createdAt).format("DD MMM, YYYY")}
                        </span>
                      )}
                    </div>
                    <div className="d-flex align-items-center g-4">
                      <AdminIcon />
                      <span className="text-xs text-gray-600">Admin</span>
                    </div>
                  </div>
                  <div className="mt-8 text-sm">
                    <div
                      dangerouslySetInnerHTML={{ __html: strippedContent }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* Modal Footer */}
      <div className="modal-footer">
        <button className="btn-outline-light" onClick={onClose}>
          Cancel
        </button>
        {selectedTransfer?.jobDetails?.mavPaymentDetails?.paymentTransfer ===
          "pending" && (
          <button
            className="btn btn-success"
            onClick={() => {
              handleMarkTransfer({
                jobId: selectedTransfer?.jobDetails?._id,
                paymentTransfer: "complete",
              });
            }}
          >
            Mark as completed
          </button>
        )}

        {selectedTransfer?.jobDetails?.mavPaymentDetails?.paymentTransfer ===
          "complete" && (
          <button
            className="btn-warning"
            onClick={() => {
              handleMarkTransfer({
                jobId: selectedTransfer?.jobDetails?._id,
                paymentTransfer: "pending",
              });
            }}
          >
            Mark as Pending
          </button>
        )}
      </div>
    </div>
  );
};

export default TransfersDetails;
